import { AppShell as MantineAppShell } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { Footer } from '../Footer';
import { SideBar } from '../SideBar';
import { TopBar } from '../TopBar';
import styles from './AppShell.module.css';

export const AppShell: React.FC<React.PropsWithChildren> = ({ children }) => {
  const [mobileOpened, { toggle: toggleMobile }] = useDisclosure();
  const [desktopOpened, { toggle: toggleDesktop }] = useDisclosure(true);

  return (
    <MantineAppShell
      header={{ height: 55 }}
      navbar={{
        width: 70,
        breakpoint: 'sm',
        collapsed: { mobile: !mobileOpened, desktop: !desktopOpened },
      }}
    >
      <MantineAppShell.Header withBorder={false}>
        <TopBar toggleMobile={toggleMobile} toggleDesktop={toggleDesktop} />
      </MantineAppShell.Header>
      <MantineAppShell.Navbar withBorder={false}>
        <SideBar />
      </MantineAppShell.Navbar>
      <MantineAppShell.Main className={styles.appShellMain}>
        {children}
        <Footer />
      </MantineAppShell.Main>
    </MantineAppShell>
  );
};
